import styled from 'styled-components';
import { ProductiveHeading07 } from 'components/styles';

export const SettingsLabelWithoutMargin = styled.p`
  ${ProductiveHeading07};
  margin-bottom: 0;
`;

export const SettingsLabel = styled.p`
  ${ProductiveHeading07};
  margin-bottom: var(--spacing-03);
`;
